import React, { useEffect, useState } from "react";
import { UserCheck, Bot, Clock, RotateCcw } from "lucide-react";
import { api, formatDate } from "../../lib/apiClient";

const ICON = {
  approved: <UserCheck className="w-4 h-4 text-emerald-600" />,
  revision_requested: <RotateCcw className="w-4 h-4 text-amber-600" />,
  skipped_by_user_auto_variant: <Bot className="w-4 h-4 text-gray-500" />,
};

function Entry({ e, kind, idx }) {
  return (
    <li className="relative pl-8 pb-5 last:pb-0" data-testid={`review-history-${kind}-${idx}`}>
      <span className="absolute left-0 top-0.5">{ICON[e.review_status] || <Clock className="w-4 h-4 text-gray-400" />}</span>
      <p className="text-sm text-gray-900">
        <strong>v{e.version}</strong> · {e.review_label}
        {e.is_current && <span className="ml-2 text-[10px] uppercase tracking-widest text-primary">vigente</span>}
      </p>
      <p className="text-xs text-gray-500">
        Generado {formatDate(e.created_at)}
        {e.reviewer_name && <> · revisado por <strong className="text-gray-700" data-testid={`review-history-reviewer-${kind}-${idx}`}>{e.reviewer_name}</strong> el {formatDate(e.reviewed_at)}</>}
      </p>
      {e.comments && <p className="text-xs text-gray-700 mt-1 italic border-l-2 border-primary/30 pl-2" data-testid={`review-history-comments-${kind}-${idx}`}>“{e.comments}”</p>}
      <p className="text-[11px] text-gray-500 mt-1" data-testid={`review-history-changes-${kind}-${idx}`}>
        {e.changed_sections === null ? "Primera versión."
          : e.changed_sections.length ? <>Cambió respecto a la anterior: {e.changed_sections.join(", ")}</>
          : "Sin cambios de contenido respecto a la versión anterior."}
      </p>
    </li>
  );
}

export function ReviewHistory({ caseId, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/cases/${caseId}/review-history`).then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, [caseId, refreshKey]);
  if (!data || (!data.diagnosis.length && !data.kit.length)) return null;
  const groups = [["diagnosis", "Diagnóstico (N1)", data.diagnosis], ["kit", "Kit Documental (N2)", data.kit]].filter(([, , list]) => list.length);
  return (
    <section className="mt-6 border border-gray-200 bg-white p-6" data-testid="review-history">
      <p className="text-[11px] uppercase tracking-widest text-primary font-medium mb-4">Historial de versiones y revisión</p>
      <div className={`grid gap-8 ${groups.length > 1 ? "md:grid-cols-2" : ""}`}>
        {groups.map(([kind, label, list]) => (
          <div key={kind}>
            <p className="text-xs text-gray-500 mb-3">{label}</p>
            <ol className="border-l border-gray-200 ml-2">{list.map((e, i) => <Entry key={e.version} e={e} kind={kind} idx={i} />)}</ol>
          </div>
        ))}
      </div>
    </section>
  );
}
